import { BaseResponse } from '../core/base-entity-service';
import CrudService from '../core/crud-service';

export interface FuturesSymbolWithMarket {
  symbol: string;
  market: string;
}

export default class FuturesSymbolsService extends CrudService {
  static override route = 'futures-symbols';

  async getSupportedSymbols(): Promise<FuturesSymbolWithMarket[]> {
    const response = await this.httpService.get<
      BaseResponse<FuturesSymbolWithMarket[]>
    >(this.path);

    return response.data;
  }
}
